<template>
  <div class="landing-page-wrapper">
    <div class="landingpage-bg">
      <img
        class="img-landingpage-bg"
        src="../../../assets/img/landingpage-bg.png"
        alt=""
      />
    </div>
    <div class="landing-top-container">
      <div class="landing-logo">
        <img
          src="../../../assets/img/isupplier-logo.png"
          class="img-landing-logo"
          alt=""
        />
      </div>
      <div class="landing-logo">
        <img
          src="../../../assets/img/logo-smm.png"
          class="img-landing-smm-logo"
          alt=""
        />
      </div>
    </div>
    <div class="landing-container">
      <div class="landing-right">
        <div class="step-indicator">
          <div class="step-wrapper">
            <div
              :class="
                $store.state.k3lStore.activeLanding == 'register'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
              @click="jumpTo('register')"
            >
              1
            </div>
            <div class="step-hr-start"></div>
            <div class="step-name">Registrasi</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('profile')"
              :class="
                $store.state.k3lStore.activeLanding == 'profile'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              2
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Profil</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('dokumentasi')"
              :class="
                $store.state.k3lStore.activeLanding == 'dokumentasi'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              3
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Dokumen Perusahaan</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('grup13')"
              :class="
                $store.state.k3lStore.activeLanding == 'grup13'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              4
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Grup 1 - 3</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('grup46')"
              :class="
                $store.state.k3lStore.activeLanding == 'grup46'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              5
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Grup 4 - 6</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('grup78')"
              :class="
                $store.state.k3lStore.activeLanding == 'grup78'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              6
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Grup 7 - 8</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('selesai')"
              :class="
                $store.state.k3lStore.activeLanding == 'selesai'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              7
            </div>
            <div class="step-hr-end"></div>
            <div class="step-name">Selesai</div>
          </div>
        </div>
        <div class="landing-form">
          <div class="landing-box">
            <!-- <router-view /> -->
            <keep-alive>
              <component :is="activeLanding" />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-footer-container">
      <span style="color:#fff; text-align:center"
        >Copyright© 2022
        <span style="color:#fff; font-weight:bold">Sinarmas Mining</span>. All
        Rights reserved</span
      >
    </div>
    <GlobalLoading
      v-if="
        $store.state.modalStore.isGlobalLoading ||
          $store.state.level1.isLoading ||
          $store.state.k3lStore.globalLoading
      "
    />
    <Notif v-if="$store.state.showModalNotif" />
  </div>
</template>
<script>
import { api, api_lp } from '@/services/config'
import axios from 'axios'
export default {
  name: 'instruction',
  data() {
    return {
      pick: '',
      errorMessage: null,
    }
  },
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    Notif: () => import('@/components/modal/Notification.vue'),
  },
  async created() {
    const request_id = this.$route.params.id

    this.setPage(request_id)
  },

  computed: {
    activeLanding: function() {
      const tab = this.$store.state.k3lStore.activeLanding

      switch (tab) {
        case 'register':
          return () => import('@/views/K3L/register.vue')
          break
        case 'profile':
          return () => import('@/views/K3L/profile.vue')
          break
        case 'dokumentasi':
          return () => import('@/views/K3L/dokumentasi.vue')
          break
        case 'grup13':
          return () => import('@/views/K3L/grup13.vue')
          break
        case 'grup46':
          return () => import('@/views/K3L/grup46.vue')
          break
        case 'grup78':
          return () => import('@/views/K3L/grup78.vue')
          break
        case 'selesai':
          return () => import('@/views/K3L/selesai-sipm.vue')
          break
        default:
          break
      }
    },
  },
  methods: {
    jumpTo(name) {
      const {
        register_step,
        profile_step,
        dokumentasi_step,
        grup13_step,
        grup46_step,
        grup78_step,
        end_step,
      } = this.$store.state.k3lStore

      if (name == 'register') {
        if (register_step) {
          this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'register' })
        } else {
          this.sendNotif()
        }
      }

      if (name == 'profile') {
        if (profile_step) {
          this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'profile' })
        } else {
          this.sendNotif()
        }
      }

      if (name == 'dokumentasi') {
        if (dokumentasi_step) {
          this.$store.commit('k3lStore/SET_ACTIVE_PAGE', {
            name: 'dokumentasi',
          })
        } else {
          this.sendNotif()
        }
      }
      if (name == 'grup13') {
        if (grup13_step) {
          this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup13' })
        } else {
          this.sendNotif()
        }
      }
      if (name == 'grup46') {
        if (grup46_step) {
          this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup46' })
        } else {
          this.sendNotif()
        }
      }
      if (name == 'grup78') {
        if (grup78_step) {
          this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup78' })
        } else {
          this.sendNotif()
        }
      }
      if (name == 'selesai' && end_step) {
        if (end_step) {
          this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'selesai' })
        } else {
          this.sendNotif()
        }
      }
    },
    sendNotif() {
      this.$store.commit(
        'SET_NOTIF',
        'Selesaikan Step Sebelumnya Terlebih Dahulu.'
      )
    },
    async setPage(id) {
      try {
        let url = `${api}/api/v1/request/session-id/${id}`

        let pendaftaran_id = null
        let bidang_usaha = ''
        let bidang_usaha_id = null
        let nama_vendor = ''
        let type_pendaftaran_id = null
        let request_id = null
        let tujuan_pendaftaran_id = null
        let vendor_ref = null
        let is_vendor_done = false
        let is_sipm_approved = false

        const { data } = await axios({
          method: 'GET',
          url,
        })

        let dataStore = data.data
        console.log(
          '🚀 ~ file: sipm-view.vue ~ line 298 ~ setPage ~ dataStore',
          dataStore
        )

        if (data && data.status == 'success') {
          pendaftaran_id = dataStore && dataStore.id
          bidang_usaha =
            dataStore && dataStore.bidang_usaha_id == 1 ? 'bu' : 'perorangan'
          bidang_usaha_id = dataStore && dataStore.bidang_usaha_id
          type_pendaftaran_id = dataStore && dataStore.type_pendaftaran_id
          nama_vendor = dataStore && dataStore.nama_vendor
          request_id = dataStore && dataStore.request_id
          vendor_ref =
            dataStore && dataStore.request && dataStore.request.vendor_ref
          is_vendor_done =
            dataStore && dataStore.request && dataStore.request.status == 6
              ? false
              : true
          is_sipm_approved =
            dataStore && dataStore.request && dataStore.request.status == 8
              ? false
              : true
          tujuan_pendaftaran_id = this.$get(
            data,
            'data.request.tujuan_pendaftaran'
          )
          if (type_pendaftaran_id == 1) {
            this.$store.commit('k3lStore/SET_K3L_FORM', {
              name: 'choosed_country',
              value: {
                id: 63,
                kode_negara: 'ID',
                negara: 'Indonesia',
                kode_telepon: '62',
                mata_uang: 'Rupiah ',
                kode_mata_uang: 'IDR',
                createdAt: '2021-12-07T07:15:27.000Z',
                updatedAt: '2021-12-07T07:15:27.000Z',
                deletedAt: null,
              },
            })
            this.$store.commit('k3lStore/SET_K3L_FORM', {
              name: 'phone_code',
              value: '+62',
            })
            this.$store.commit('k3lStore/SET_K3L_FORM', {
              name: 'mata_uang',
              value: 'IDR',
            })
            this.$store.commit('k3lStore/SET_K3L_FORM', {
              name: 'phoneDirektur',
              value: '+62',
            })
            this.$store.commit('k3lStore/SET_K3L_FORM', {
              name: 'phoneKomisaris',
              value: '+62',
            })
            this.$store.commit('k3lStore/SET_K3L_FORM', {
              name: 'k3l_pic_phone_code',
              value: '+62',
            })
          }

          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'request_id',
            value: request_id,
          })
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'is_vendor_done',
            value: is_vendor_done,
          })
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'is_sipm_approved',
            value: is_sipm_approved,
          })
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'vendor_ref',
            value: vendor_ref,
          })
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'pendaftaran_id',
            value: pendaftaran_id,
          })
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'tujuan_pendaftaran_id',
            value: tujuan_pendaftaran_id,
          })
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'bidang_usaha_id',
            value: bidang_usaha_id,
          })
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'type_pendaftaran_id',
            value: type_pendaftaran_id,
          })
          await this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'k3l_vendor_name',
            value: nama_vendor,
          })
          await this.getInformasi(vendor_ref)
          await this.getParent(id)
          await this.getChild(id)
          await this.getK3l(id)
          await this.getSistemManajemen(id)
          await this.getCompetencies(id)
          await this.getDocument(id)
        }
      } catch (error) {
        console.log('error index k3l: ', error)
        await this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
        // await this.$router.push('/')
      }
    },
    async getInformasi(vendor_id) {
      const url = `${api}/api/v1/d-vendor-informasi?id=${vendor_id}`

      await this.$store.commit('k3lStore/SET_K3L_FORM', {
        name: 'globalLoading',
        value: true,
      })
      await axios({
        method: 'GET',
        url,
      })
        .then(async ({ data }) => {
          let informasi = data.data
          console.log('informasi: ', informasi)
          this.$store.commit('k3lStore/UPDATE_INFORMASI', informasi)
          await this.getLegalitas(vendor_id)
        })
        .catch(error => {
          // do nothing
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },

    async getLegalitas(vendor_id) {
      const url = `${api}/api/v1/d-vendor-legal-document?vendor_id=${vendor_id}`
      axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          console.log('data legal: ', data.data)
          let legal = data.data
          this.$store.commit('k3lStore/UPDATE_LEGAL', legal)
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          // do nothing
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },

    async getParent(id) {
      const url = `${api_lp}/api/v1/vendor/parent/${id}`

      await this.$store.commit('k3lStore/SET_K3L_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 470 ~ .then ~ data',
            data
          )

          let result = data.data
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'parent_companies',
            value: result,
          })
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 469 ~ getParent ~ error',
            error
          )
          // do nothing
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },

    async getChild(id) {
      const url = `${api_lp}/api/v1/vendor/child/${id}`

      await this.$store.commit('k3lStore/SET_K3L_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 470 ~ .then ~ data',
            data
          )

          let result = data.data
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'child_companies',
            value: result,
          })
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 469 ~ getParent ~ error',
            error
          )
          // do nothing
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },

    async getSistemManajemen(id) {
      const url = `${api_lp}/api/v1/vendor/sistem-manajemen/${id}`

      await this.$store.commit('k3lStore/SET_K3L_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 470 ~ .then ~ data',
            data
          )

          let result = data.data
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'addedSistemManajemen',
            value: result,
          })
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 469 ~ getParent ~ error',
            error
          )
          // do nothing
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },

    async getCompetencies(id) {
      const url = `${api_lp}/api/v1/vendor/sertifikat/${id}`

      await this.$store.commit('k3lStore/SET_K3L_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 470 ~ .then ~ data',
            data
          )

          let result = data.data
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'addedCompetencies',
            value: result,
          })
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 469 ~ getParent ~ error',
            error
          )
          // do nothing
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },

    async getDocument(id) {
      const url = `${api_lp}/api/v1/vendor/doc-list/${id}`

      await this.$store.commit('k3lStore/SET_K3L_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 470 ~ .then ~ data',
            data
          )

          let result = data.data
          this.$store.commit('k3lStore/SET_DOCUMENT_LIST', result)
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 469 ~ getParent ~ error',
            error
          )
          // do nothing
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },

    async getK3l(id) {
      const url = `${api_lp}/api/v1/vendor/k3l-detail/${id}`

      await this.$store.commit('k3lStore/SET_K3L_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 470 ~ .then ~ data',
            data
          )

          let result = data.data
          this.$store.commit('k3lStore/SET_K3L_DETAIL', result)
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 469 ~ getParent ~ error',
            error
          )
          // do nothing
          this.$store.commit('k3lStore/SET_K3L_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },
  },
}
</script>
